import React, { Component } from "react";
import SimpleModal from "./SimpleModal";
import Button from "../commons/Button";
import FlexView from "react-flexview";
import SimpleInputPassword from "../SimpleInputPassword";
import Api from "../../Services/Api";

class ProfileChangePasswordModal extends Component {
  handleSubmitForm = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const requestBody = {
      userId: this.props.username,
      oldPassword: formData.get("oldPassword"),
      newPassword: formData.get("newPassword"),
      confirmPassword: formData.get("confirmPassword"),
    };

    Api.create("NAGAMAS_AUTH").postChangePassword(requestBody)
        .then((res) => {
          if (res.ok) {
            alert("Successfully change your password. Please login again.");
            this.props.onClickClose();
          }
        })
        .catch((e) => {
          alert(e.message);
        });
  };

  render() {
    const { visible, onClickClose } = this.props;

    return (
      <SimpleModal
        title="Change Password"
        visible={visible}
        onClickClose={onClickClose}
        styles={{
          width: "500px",
        }}
        content={
          <form
            onSubmit={this.handleSubmitForm}
            style={{ padding: "1rem 2rem", textAlign: "left" }}
          >
            <SimpleInputPassword
              mandatory
              id="input_text_old_password"
              name="oldPassword"
              label="Old Password"
            />
            <SimpleInputPassword
              mandatory
              id="input_text_new_password"
              name="newPassword"
              label="New Password"
            />
            <SimpleInputPassword
              mandatory
              id="input_text_confirm_password"
              name="confirmPassword"
              label="Confirm Password"
            />
            <FlexView vAlignContent="center" hAlignContent="center">
              <Button
                type="button"
                style={{ width: "130px", height: "40px" }}
                onClick={onClickClose}
                className="btn btn-plus background-red margin-left-5px margin-right-5px"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                style={{ width: "130px", height: "40px" }}
                className="btn btn-plus background-red margin-left-5px margin-right-5px"
              >
                Save
              </Button>
            </FlexView>
          </form>
        }
      />
    );
  }
}

export default ProfileChangePasswordModal;
